var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 124.266,
    y1: 76.367,
    x2: 214.257,
    y2: 76.367
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 124.266,
    y1: 180.028,
    x2: 214.257,
    y2: 180.028
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M53.235,77.277l9.659,13.094c0,0,5.795-18.078,25.113-26.667"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.402,
    y: 51.038,
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 54.783,
    height: 50.659
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.402,
    y: 154.698,
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 54.783,
    height: 50.659
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 220,
    height: 220
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.f2ceaccb2a5d2332f75bde6524b5ba97.svg";
export { ForwardRef as ReactComponent };